import { z } from 'zod';

const SERVICE_ACCESS_TEMPLATE_CODES = {
    DEFAULT: 'DEFAULT',
    // Program Owners
    ACCESS_PROGRAM_OWNER: 'ACCESS_PROGRAM_OWNER',
    OMNI_PROGRAM_OWNER: 'OMNI_PROGRAM_OWNER',
    DEALER_PROGRAM_OWNER: 'DEALER_PROGRAM_OWNER',
    DEALER_SOLO_ROOFTOP: 'DEALER_SOLO_ROOFTOP',
    // Rooftops
    OMNI_ROOFTOP: 'OMNI_ROOFTOP',
    DEALER_ROOFTOP: 'DEALER_ROOFTOP',
    PICKUP_LOCATION: 'PICKUP_LOCATION',
    // AI BDC
    AI_BDC: 'AI_BDC',
    // Internal
    EKHO_FULL_ACCESS: 'EKHO_FULL_ACCESS',
};
const serviceAccessTemplateCodeValues = [
    SERVICE_ACCESS_TEMPLATE_CODES.DEFAULT,
    SERVICE_ACCESS_TEMPLATE_CODES.ACCESS_PROGRAM_OWNER,
    SERVICE_ACCESS_TEMPLATE_CODES.OMNI_PROGRAM_OWNER,
    SERVICE_ACCESS_TEMPLATE_CODES.DEALER_PROGRAM_OWNER,
    SERVICE_ACCESS_TEMPLATE_CODES.DEALER_SOLO_ROOFTOP,
    SERVICE_ACCESS_TEMPLATE_CODES.OMNI_ROOFTOP,
    SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP,
    SERVICE_ACCESS_TEMPLATE_CODES.PICKUP_LOCATION,
    SERVICE_ACCESS_TEMPLATE_CODES.AI_BDC,
    SERVICE_ACCESS_TEMPLATE_CODES.EKHO_FULL_ACCESS,
];
const serviceAccessTemplateCodeSchema = z.enum(serviceAccessTemplateCodeValues);

export { SERVICE_ACCESS_TEMPLATE_CODES, serviceAccessTemplateCodeSchema };
//# sourceMappingURL=ServiceAccessTemplateCode.js.map
